const getExpertsRating = (rating = 0) => (
  Math.min(Math.floor(rating * 5 + 1), 5)
);

module.exports.getExpertsRating = getExpertsRating;
